{
  "$id": "module://role-publish",
  "$schema": "wealthlane://schemas/domain",
  "title": "Role Publish",
  "type": "object",
  "properties": {
    "sourceRoleId": {
      "type": "string",
      "title": "Role",
      "widget": "select",
      "actionId": "FETCH_ROLE_PUBLISH_ROLE_OPTIONS",
      "required": true,
      "noBlank": true
    },
    "destinationCompanyId": {
      "type": "array",
      "title": "Publish to Company",
      "widget": "select",
      "actionId": "FETCH_ROLE_PUBLISH_DESTINATION_COMPANIES",
      "required": true
    }
  }
}
